import React, { Component } from "react";
import { Table, Button, Input, Switch, Modal, message, Tooltip } from "antd";
import axios from "axios";
import "./Pages.css";
import UsuarioForm from '../components/UsuarioForm';
import UsuarioEmpForm from '../components/UsuarioEmpForm';
import moment from "moment";
import { maskCPF } from "../utils/Masker";
import numeral from "numeral";
import Colors from '../utils/Colors';

const { Column } = Table;
const ButtonGroup = Button.Group;
const { Search } = Input;

export default class extends Component {
  state = {
    formVisivel: false,
    formVisivelUsuEmp: false,
    listaRegistros: [],
    carregando: false,
    pagina: 1,
    limite: 20,
    total: 0,
    novoReg: false,
  };

  componentDidMount() {
    this.getListaRegistros();
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      }, this.getListaRegistros)
    }
  }



  getListaRegistros = () => {
    this.setState({ carregando: true });
    const { busca, pagina, limite } = this.state;
    axios
      .get('/usuarios', {
        params: {
          page: pagina,
          limite: limite,
          nome: busca,
        }
      })
      .then(response => {
        const { data, total, current_page, per_page } = response.data;
        this.setState({
          listaRegistros: data,
          carregando: false,
          total: total,
          pagina: current_page,
          limite: Number(per_page),
        });
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        });
      });
  };




  onSalvarClick = (registro) => {
    this.setState({
      salvando: true
    })

    let request;
    if (this.state.novoReg === false) {
      request = axios.put(`/usuarios/update/${registro.usu_cpf}`, registro);
    } else {
      request = axios.post(`/usuarios/store`, registro)
    }

    request
      .then(response => {
        this.getListaRegistros();
        this.setState({
          formVisivel: false,
          salvando: false,
        })
        message.success('Usuário gravado com sucesso.');
      })
      .catch(error => {
        let mensagem = '';
        if (error.response.data.usu_cpf) {
          mensagem = error.response.data.usu_cpf;
        } else if (error.response.data.usu_email) {
          mensagem = error.response.data.usu_email;
        } else if (error.response.data.usu_nome) {
          mensagem = error.response.data.usu_nome;
        }

        console.error(error.response);
        this.setState({
          salvando: false
        })
        Modal.error({ title: 'Erro Inesperado', content: 'Não foi possível salvar. ' + mensagem, okText: 'OK', })
      })
  }

  onEditarClick = registro => {
    this.setState({ carregando: true });
    axios.get(`/usuarios/show/${registro.usu_cpf}`)
      .then(response => {
        const { data } = response;

        data.ue_grupo = {
          key: String(data.ue_grupo),
          label: data.gu_descricao,
        }

        data.usu_cpf = maskCPF(data.usu_cpf);
        data.ue_vendedor = data.ue_vendedor ? true : false;

        data.check_duplicar = data.ue_duplicar_pedido === 'N' ? false : true;
        data.opcao_duplicar = {
          key: String(data.ue_duplicar_pedido),
          label: '',
        }
        data.ue_clientes_vendedor = {
          key: String(data.ue_clientes_vendedor),
          label: '',
        }

        data.ue_tipo_impressao_pedido = {
          key: String(data.ue_tipo_impressao_pedido),
          label: '',
        }

        data.ue_tipo_frete = {
          key: data.ue_tipo_frete ? String(data.ue_tipo_frete) : 'XXX',
          label: '',
        }

        data.ue_tipo_pedido_padrao = {
          key: data.ue_tipo_pedido_padrao ? String(data.ue_tipo_pedido_padrao) : 0,
          label: '',
        }

        data.ue_plataforma_acesso = {
          key: data.ue_plataforma_acesso ? String(data.ue_plataforma_acesso) : 'T',
          label: '',
        }

        data.ue_tipo_calculo_frete = {
          key: data.ue_tipo_calculo_frete ? String(data.ue_tipo_calculo_frete) : 'SEM',
          label: '',
        }

        data.ue_cod_tabela_desconto = {
          key: data.ue_cod_tabela_desconto ? String(data.ue_cod_tabela_desconto) : 0,
          label: data.td_descricao ? String(data.td_descricao) : '',
        }

        data.ue_linha_producao = {
          key: data.ue_linha_producao ? String(data.ue_linha_producao) : 0,
          label: data.lp_descricao ? String(data.lp_descricao) : '',
        }

        data.ue_forca_sinc_cad_flag = String(data.ue_forca_sinc_cad).substring(0, 1) === 'S' ? true : false;
        data.ue_forca_sinc_cad_dias = String(data.ue_forca_sinc_cad).substring(1, 5) !== '' ? String(data.ue_forca_sinc_cad).substring(1, 5) : '0';

        this.setState({
          formVisivel: true,
          registroSelecionado: data,
          carregando: false,
          novoReg: false,
        })
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };


  onExcluirClick = registro => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este registro?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        this.setState({ carregando: true });
        axios.delete(`/usuarios/delete/${registro.usu_cpf}`)
          .then(response => {
            const { listaRegistros, total } = this.state;
            const registroIndex = listaRegistros.findIndex(tar => tar.usu_cpf === registro.usu_cpf)
            listaRegistros.splice(registroIndex, 1);
            this.setState({
              listaRegistros: listaRegistros.concat([]),
              total: total - 1,
              carregando: false,
            })

          }).catch(error => {
            console.error(error.response);
            this.setState({
              carregando: false,
            })
            Modal.error({ title: 'Erro Inesperado', content: 'Não foi possível excluir. ' + error.response.data, okText: 'OK', })
          })
      }
    })
  };




  onSalvarUsuEmpClick = (registro) => {
    this.setState({
      salvando: true
    })

    axios.post(`/empresaUsuarios/store`, registro)
      .then(response => {
        this.getListaRegistros();
        this.setState({
          formVisivelUsuEmp: false,
          salvando: false,
        })
        message.success('Usuário gravado com sucesso.');
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          salvando: false
        })
        if ((error.response) && (error.response.status === 412)) {
          if (error.response.data.ue_usuario) {
            Modal.info({ title: 'Atenção!', content: 'Não foi possível salvar. ' + error.response.data.ue_usuario, okText: 'OK', })
          } else {
            Modal.error({ title: 'Erro Inesperado', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
          }
        } else {
          Modal.error({ title: 'Erro Inesperado', content: 'Não foi possível salvar. ' + error.response.data, okText: 'OK', })
        }

      })
  }





  onBuscar = (texto) => {
    this.setState({
      busca: texto
    },
      this.getListaRegistros);
  };

  onAdicionarClick = () => {
    this.setState({
      formVisivel: true,
      novoReg: true,
      registroSelecionado: {
        novoReg: true,
        checkedDescPerc: false,

        usu_cpf: '',
        usu_senha: '123456',
        ue_grupo: { key: '' },
        check_duplicar: false,
        opcao_duplicar: 'M',

        ue_linha_producao: { key: '0', label: '' },
        ue_clientes_vendedor: { key: 'TOD', label: '' },
        ue_tipo_impressao_pedido: { key: 'A4', label: '' },
        ue_tipo_pedido_padrao: { key: 'P', label: '' },
        ue_plataforma_acesso: { key: 'T', label: '' },
        ue_tipo_calculo_frete: { key: 'SEM', label: '' },

        ue_tipo_frete: {
          key: 'CIF',
          label: '',
        },
      },
    })
  };

  onCancelarClick = () => {
    this.setState({
      formVisivel: false
    })
  }




  onAdicionarUsuEmpClick = () => {
    this.setState({
      formVisivelUsuEmp: true,
    })
  };

  onCancelarUsuEmpClick = () => {
    this.setState({
      formVisivelUsuEmp: false
    })
  }




  onAtivaChange = (registro, ativar) => {
    this.setState({
      carregando: true
    })
    let request;

    if (ativar) {
      request = axios.put(`/usuarios/ativa/${registro.usu_cpf}/1`)
    } else {
      request = axios.put(`/usuarios/ativa/${registro.usu_cpf}/0`)
    }

    request.then(response => {
      registro.ue_situacao = ativar;
      this.setState({
        listaRegistros: this.state.listaRegistros.concat([]),
        carregando: false
      })
    }).catch(error => {
      console.error(error.response);
      this.setState({
        carregando: false
      })
    })
  };


  renderAtiva = (ue_situacao, registro) => {
    return (
      <Switch
        checkedChildren="Ativo"
        unCheckedChildren="Inativo"
        checked={ue_situacao ? true : false}
        onChange={ativar => this.onAtivaChange(registro, ativar)}
        style={{ backgroundColor: !ue_situacao ? null : Colors.primary }}
      />
    );
  };


  onOnLineChange = (registro, ativar) => {
    this.setState({
      carregando: true
    })
    let request;

    if (ativar) {
      request = axios.put(`/usuarios/online/${registro.usu_cpf}/1`)
    } else {
      request = axios.put(`/usuarios/online/${registro.usu_cpf}/0`)
    }

    request.then(response => {
      registro.ue_flag_online = ativar;
      this.setState({
        listaRegistros: this.state.listaRegistros.concat([]),
        carregando: false
      })
    }).catch(error => {
      console.error(error.response);
      this.setState({
        carregando: false
      })
    })
  };


  renderOnline = (ue_flag_online, registro) => {
    return (
      <Switch
        checkedChildren="OnLine"
        unCheckedChildren="OffLine"
        checked={ue_flag_online ? true : false}
        onChange={ativar => this.onOnLineChange(registro, ativar)}
        style={{ backgroundColor: !ue_flag_online ? null : Colors.primary }}
      />
    );
  };


  renderAcoes = (text, registro) => {
    return (
      <ButtonGroup size="small">
        <Tooltip title="Editar" placement="left">
          <Button className="botoesModalFormEditar" size="small" onClick={() => this.onEditarClick(registro, false)} icon="edit" />
        </Tooltip>
        <Tooltip title="Excluir" placement="right">
          <Button className="botoesModalFormExcluir" size="small" onClick={() => this.onExcluirClick(registro)} icon="delete" />
        </Tooltip>
      </ButtonGroup>
    );
  };

  renderData = (data) => {
    const dataMoment = moment(data);
    return (
      <span>
        {dataMoment.format('DD/MM/YYYY HH:mm')}
      </span>
    )
  }

  renderCPF = (usu_cpf) => {
    return maskCPF(usu_cpf);
    // return usu_cpf;
  }

  renderValor = (valor) => {
    return (
      <span style={{ fontSize: 11 }}> {numeral(parseFloat(valor)).format('0,000.00')} </span>
    );
  };

  renderFlag = (flag) => {
    if (flag) {
      return (
        <span>SIM</span >
      )
    } else {
      return (
        <span>NÂO</span >
      )
    }
  }

  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros)
  })


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, formVisivel, formVisivelUsuEmp, salvando, registroSelecionado,
      total, pagina, limite, busca } = this.state;

    // console.log('render: ', this.state);

    return (
      <div className="contentRoutesContainer">
        <h2 className="tituloPage">Cadastro de Usuários</h2>
        <hr />
        <br />

        <div className="pageFiltro">
          <Tooltip title="Adiciona novo Usuário" placement="topLeft">
            <Button
              onClick={this.onAdicionarClick}
              className="pageFiltro-adicionar"
            >
              Adicionar
            </Button>
          </Tooltip>

          <Tooltip title="Incluir usuário já está cadastrado" placement="topLeft">
            <Button
              onClick={this.onAdicionarUsuEmpClick}
              className="pageFiltro-adicionar"
            >
              Incluir
            </Button>
          </Tooltip>

          <Search
            placeholder="Buscar por Nome do Usuário"
            onSearch={this.onBuscar}
            enterButton
            className="pageFiltro-busca"
          />

          <UsuarioForm
            visivel={formVisivel}
            onSalvarClick={this.onSalvarClick}
            onCancelarClick={this.onCancelarClick}
            carregando={salvando}
            registroSelecionado={registroSelecionado}
          />

          <UsuarioEmpForm
            visivel={formVisivelUsuEmp}
            onSalvarUsuEmpClick={this.onSalvarUsuEmpClick}
            onCancelarUsuEmpClick={this.onCancelarUsuEmpClick}
            carregando={salvando}
            registroSelecionado={registroSelecionado}
          />
        </div>

        <br />

        <Table
          pagination={{
            total: total,
            pageSize: limite,
            current: pagina,
            pageSizeOptions: ['10', '20', '30', '40'],
            showSizeChanger: true,
          }}
          onChange={this.onTabelaChange}
          loading={{
            spinning: carregando,
            tip: 'Carregando. Aguarde...',
            size: "large"
          }}
          rowKey={(registro => registro.usu_cpf)}
          dataSource={listaRegistros}
          scroll={{ x: 600, y: false }}
        >
          <Column
            key="usu_cpf"
            dataIndex="usu_cpf"
            title="CPF"
            width={100}
            align="center"
            fixed='left'
            render={this.renderCPF}
            className="listaCadastro"
          />
          <Column
            key="usu_nome"
            dataIndex="usu_nome"
            title="Nome"
            width={200}
            align="left"
            fixed='left'
            className="listaCadastro"
          />
          <Column
            key="gu_descricao"
            dataIndex="gu_descricao"
            title="Grupo"
            width={130}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="usu_email"
            dataIndex="usu_email"
            title="Email"
            width={200}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="ue_dt_ult_acesso"
            dataIndex="ue_dt_ult_acesso"
            title="Último Acesso"
            width={120}
            align="center"
            render={this.renderData}
            className="listaCadastro"
          />
          <Column
            key="ue_dt_sincronizou"
            dataIndex="ue_dt_sincronizou"
            title="Sincronização"
            width={120}
            align="center"
            render={this.renderData}
            className="listaCadastro"
          />
          <Column
            key="ue_versao_app"
            dataIndex="ue_versao_app"
            title="Versão App"
            width={80}
            align="center"
            className="listaCadastro"
          />
          <Column
            key="ue_so"
            dataIndex="ue_so"
            title="S.O"
            width={80}
            align="center"
            className="listaCadastro"
          />

          <Column
            key="ue_flag_online"
            dataIndex="ue_flag_online"
            title="OnLine"
            render={this.renderOnline}
            width={100}
            align="center"
            className="listaCadastro"
          />
          <Column
            key="ue_situacao"
            dataIndex="ue_situacao"
            title="Situação"
            render={this.renderAtiva}
            width={100}
            align="center"
            className="listaCadastro"
          />
          <Column
            key="acoes"
            title="Ações"
            render={this.renderAcoes}
            width={100}
            align="center"
            className="listaCadastro"
          />



          <Column
            key="ue_vendedor"
            dataIndex="ue_vendedor"
            title="Vendedor"
            render={this.renderFlag}
            width={100}
            align="center"
            className="listaCadastro"
          />
          <Column
            key="ue_cod_vendedor"
            dataIndex="ue_cod_vendedor"
            title="Cod. Vendedor"
            width={100}
            align="center"
            className="listaCadastro"
          />
          <Column
            key="ue_bloq_venda_cli_dev"
            dataIndex="ue_bloq_venda_cli_dev"
            title="Bloaqueia Venda para Devedor"
            render={this.renderFlag}
            width={100}
            align="center"
            className="listaCadastro"
          />
          <Column
            key="ue_bloq_venda_sem_est"
            dataIndex="ue_bloq_venda_sem_est"
            title="Bloqueia Venda sem Estoque"
            render={this.renderFlag}
            width={100}
            align="center"
            className="listaCadastro"
          />
          <Column
            key="ue_avisar_venda_sem_est"
            dataIndex="ue_avisar_venda_sem_est"
            title="Avisa Venda sem Estoque"
            render={this.renderFlag}
            width={100}
            align="center"
            className="listaCadastro"
          />
          <Column
            key="ue_flag_bonificacao"
            dataIndex="ue_flag_bonificacao"
            title="Venda Bonificação"
            render={this.renderFlag}
            width={100}
            align="center"
            className="listaCadastro"
          />
          <Column
            key="ue_flag_mostrar_tabelas"
            dataIndex="ue_flag_mostrar_tabelas"
            title="Mostra Tabela Preços"
            render={this.renderFlag}
            width={100}
            align="center"
            className="listaCadastro"
          />
          <Column
            key="ue_tabela_padrao"
            dataIndex="ue_tabela_padrao"
            title="Tabela Padrão"
            width={100}
            align="center"
            className="listaCadastro"
          />
          <Column
            key="ue_flag_desconto_tab1"
            dataIndex="ue_flag_desconto_tab1"
            title="Desconto Tabela 1"
            render={this.renderFlag}
            width={100}
            align="center"
            className="listaCadastro"
          />
          <Column
            key="ue_perc_desconto_tab1"
            dataIndex="ue_perc_desconto_tab1"
            title="% Desconto Tabela 1"
            render={this.renderValor}
            width={100}
            align="right"
            className="listaCadastro"
          />
          <Column
            key="ue_flag_desconto_tab2"
            dataIndex="ue_flag_desconto_tab2"
            title="Desconto Tabela 2"
            render={this.renderFlag}
            width={100}
            align="center"
            className="listaCadastro"
          />
          <Column
            key="ue_perc_desconto_tab2"
            dataIndex="ue_perc_desconto_tab2"
            title="% Desconto Tabela 2"
            render={this.renderValor}
            width={100}
            align="right"
            className="listaCadastro"
          />
          <Column
            key="ue_flag_tabela_preco_minimo"
            dataIndex="ue_flag_tabela_preco_minimo"
            title="Verifica Preço Mínimo"
            render={this.renderFlag}
            width={100}
            align="center"
            className="listaCadastro"
          />
          <Column
            key="ue_duplicar_pedido"
            dataIndex="ue_duplicar_pedido"
            title="Duplicar Pedido"
            width={100}
            align="center"
            className="listaCadastro"
          />
          <Column
            key="ue_forca_sinc_cad"
            dataIndex="ue_forca_sinc_cad"
            title="Forçar Sincronização"
            render={this.renderFlag}
            width={100}
            align="center"
            className="listaCadastro"
          />
          <Column
            key="ue_clientes_vendedor"
            dataIndex="ue_clientes_vendedor"
            title="Clientes que o usuário pode buscar"
            width={100}
            align="center"
            className="listaCadastro"
          />
          <Column
            key="ue_tipo_impressao_pedido"
            dataIndex="ue_tipo_impressao_pedido"
            title="Modelo Impressão Pedido"
            width={100}
            align="center"
            className="listaCadastro"
          />
          <Column
            key="td_descricao"
            dataIndex="td_descricao"
            title="Tabela de Desconto"
            width={100}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="ue_tipo_frete"
            dataIndex="ue_tipo_frete"
            title="Tipo Frete"
            width={100}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="ue_tipo_calculo_frete"
            dataIndex="ue_tipo_calculo_frete"
            title="Tipo Calculo Frete"
            width={100}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="ue_tipo_pedido_padrao"
            dataIndex="ue_tipo_pedido_padrao"
            title="Tipo Pedido Padrão"
            width={100}
            align="left"
            className="listaCadastro"
          />
          <Column
            key="ue_flag_ultimo_preco_vendido"
            dataIndex="ue_flag_ultimo_preco_vendido"
            title="Controla último preço comercializado"
            render={this.renderFlag}
            width={100}
            align="center"
            className="listaCadastro"
          />

        </Table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/UsuariosPage.js